<template>
    <div class="container-fluid change-password-body">
        <div class="row change-password-header">
            <div class="autodesk-logo-header">
                <img class="autodesk-logo" src="../assets/images/employeehub-logo.svg" @click="navigateToHome()"/>
            </div>
        </div>
        <change-password-login-body/>
        <password-management-footer/>
    </div>

</template>

<script>
    import ChangePasswordLoginBody from '@/components/ChangePasswordLoginBody.vue'
    import PasswordManagementFooter from "./PasswordManagementFooter"

    export default {
        name: 'change-password',
        components: {
            PasswordManagementFooter,
            ChangePasswordLoginBody
        },
        created() {
            this.$store.commit('setDomain', this.$route.meta.domain);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .autodesk-logo-header{
        height: min-content;
        margin-bottom: 0;
        border-radius: 0;
        min-height: 60px;
        padding-right: 28px;
        padding-left: 28px;

        border: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

    }
    .change-password-body {
        min-width: 315px;
    }
    .change-password-header {
        background-color: #000000;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
